import { lazy, Suspense } from 'react';
import { RouteObject, useRoutes, BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '~/core/components/contexts/ErrorBoundary';
import Loading from '~/core/presentation/layout/global/Loading';
import PublicRouter from './PublicRouter';
import PrivateRouter from './PrivateRouter';

export const Router: React.FC = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <Suspense fallback={<Loading />}>
        <InnerRouter />
      </Suspense>
    </ErrorBoundary>
  </BrowserRouter>
);

function InnerRouter(): JSX.Element {
  console.log('🌐 Router principal - URL atual:', window.location.pathname);
  
  const routes: RouteObject[] = [
    // Rotas privadas - captura /dashboard e todos os sub-paths
    {
      path: '/dashboard/*',
      element: <PrivateRouter />,
    },
    // Rotas públicas
    {
      path: '/*',
      element: <PublicRouter />,
    },
  ];

  const element = useRoutes(routes);
  console.log('🎯 Router principal - Elemento sendo renderizado:', element);
  return <div>{element}</div>;
}
